import { useState } from "react";
import noticeIcon from '../../images/common/i_3d_notice.svg'

export default function NoticePopup({
  // 디폴트
  visible = true,
  onClose,
  maintenanceTime = "18시 이후",
  duration = "약 1시간 소요 예정",
  title = "서버 점검으로 인해 서비스 이용이\n일시적으로 제한됩니다.",
  description = "이용에 불편을 드려 죄송합니다.",
  descriptionSub = "",
}) {
  if (!visible) return null;

  const highlightedTime = maintenanceTime.replace(
    /(오후 \d+시)/g,
    '<span class="highlight">$1</span>'
  );

  return (
    <>
      <style>{`
        
        .mp-overlay {
            position: fixed;
            inset: 0;
            background: rgba(0, 0, 0, 0.55);
            backdrop-filter: blur(2px);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 9999;
            animation: mp-fade-in 0.2s ease;
            padding: 24px;
        }

        @keyframes mp-fade-in {
            from { opacity: 0; }
            to   { opacity: 1; }
        }

        .mp-card {
            background: #ffffff;
            border-radius: 24px;
            padding: 36px 28px 24px;
            width: 100%;
            max-width: 360px;
            text-align: center;
            box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);
            animation: mp-slide-up 0.28s cubic-bezier(0.34, 1.3, 0.64, 1);
        }

        @keyframes mp-slide-up {
            from { opacity: 0; transform: translateY(24px) scale(0.96); }
            to   { opacity: 1; transform: translateY(0)    scale(1);    }
        }

        .mp-icon-wrap {
            width: 100px;
            height: 100px;
            background: #f0f4ff;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 24px;
        }

        .mp-icon-wrap .emoji {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 95%;
            height: 95%;         
            animation: mp-shake 0.6s 0.4s ease both;
            background: url(${noticeIcon}) no-repeat center;
            background-size: auto 100%;   
        }

        @keyframes mp-shake {
            0%   { transform: rotate(0deg); }
            20%  { transform: rotate(-12deg); }
            40%  { transform: rotate(10deg); }
            60%  { transform: rotate(-6deg); }
            80%  { transform: rotate(4deg); }
            100% { transform: rotate(0deg); }
        }

        .mp-title {
            font-size: var(--mo-fz-lg);
            font-weight: var(--fz-weight-700);
            color: var(--color-important);
        }

        .mp-time-box {
            display: inline-block;
            border-radius: var(--radius-12);
            padding: var(--sp-12);

        }

        .mp-time-box .main-time {
            padding: 0 var(--sp-10);
            font-size: var(--mo-fz-md);
            color: var(--color-main-gray);
            font-weight: var(--fz-weight-500);
            
            span {
                color: var(--color-main-5);
                font-weight: var(--fz-weight-700);    
            }
        }

        .mp-time-box .row .highlight {
            color: var(--color-main-5);
            font-weight: var(--fz-weight-700);
        }

        .mp-time-box .sub {
            font-size: var(--mo-fz-smd);;
            color: var(--color-main-gray-5);
        }

        .mp-desc {
            font-size: var(--mo-fz-md);
            color: var(--color-main-gray);
        }

        .mp-desc-sub {
            font-size: var(--mo-fz-smd);
            color: var(--color-main-gray-5);
        }

        .mp-card button {
            margin-top: var(--sp-20);
        }

      `}</style>

      <div className="mp-overlay">
        <div className="mp-card" onClick={(e) => e.stopPropagation()}>
          <div className="mp-icon-wrap">
            <span className="emoji"></span>
          </div>

          <p className="mp-title">{title}</p>

          <div className="mp-time-box">
            <p className="main-time">
                점검 시간 :  <span >{maintenanceTime}</span>
            </p>
            <p className="sub">({duration})</p>
          </div>

          <p className="mp-desc">{description}</p>
          <span className="mp-desc-sub">{descriptionSub}</span>

          <button className="btn" data-btn-type="fill-gray" data-btn-size='lg' data-btn-width='full' onClick={onClose}>
            닫기
          </button>
        </div>
      </div>
    </>
  );
}
